/* 周瑜（字公瑾） */
import { gd } from '../../core/kit.ts';
import type { Unit } from '../types.ts';
import { defineHero, hook, D } from '../define.ts';

export default defineHero({
  id: 'zhouyu', name: '周瑜', sub: '字公瑾', faction: 'wu', role: '法師', weapon: 'sword',
  look: {
    ranged: true,
    weaponName: '佩劍', robe: true, skin: '#f3d0a8', hair: '#1a1618', head: 'guan', fx: '#ff8a3a',
    c: { armor: '#d8b25a', sleeve: '#b33a30', cloth: '#b33a30', trim: '#e9c46a', pants: '#3a2323', boot: '#2a1f1f', belt: '#6e1f1b', metal: '#dfe5ea', plume: '#e9c46a', pole: '#3a2a22' },
  },
  skills: [
    ['赤壁火箭', 'bolt', '射出火球造成 {86/140/194/248} 傷害，並讓目標燃燒 2 秒。', { shape: 'fire' }],
    ['反間計', 'hook', '射出反間書信，命中第一名敵將時，讓他 {0.8/1/1.2/1.4} 秒內倒戈攻擊自己的隊友。', { x: { k: 'turncoat', dur: [0.8, 1, 1.2, 1.4] }, aim: D(600, 24), el: 'shadow' }],
    ['曲有誤', 'passive', '技能傷害 +{12/17/22/27}%，東風期間再 +10%。', { pv: { sp: [12, 17, 22, 27] }, sig: 'eastwind' }],
    ['火燒連環', 'fire', '沿前方地面接連點燃四道火柱，每道 {200/305/410} 傷害；著火的敵人會把火延燒給身旁的隊友（連環）。', { sig: 'chainfire' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 周瑜「反間計」：命中第一名敵將，讓他短暫倒戈
    turncoat(u, a, X) {
      this.shootProj(u, { dir: a.dir, speed: 1000, range: this.skillRange(a.sk, a.lvl), rad: 20, shape: 'orb', col: '#b07cff', big: true, filter: (t: Unit) => t.kind === 'hero',
        onHit: (t: Unit) => {
          if (t.bf && t.bf.immune) return true;
          t.mcTeam = t.team; t.mcT = this.t + X.dur; t.team = u.team; t.owner = u; t.act = null;
          if (t.input) { t.input.target = null; t.input.moveTo = null; t.input.skill = null; }
          this.fx({ k: 'slam', x: t.x, y: t.y, col: '#b07cff' });
          this.later(X.dur, () => this.endForge(t));
          return true;
        } });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 曲有誤：東風期間技能再 +10%
    hook('damage.before', 110, function (c) { const own0 = c.own, o = c.o; if (own0.sg && own0.sg.eastwind && o && (o.spell || o.sk) && this.wind && this.wind.on > 0) c.a *= 1.1; }),
  ],
  // 電腦什麼時候放這招
  ai: {
    turncoat: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 580 && w.units.some((o) => o !== t && o.alive && o.kind === 'hero' && o.team === t!.team && gd(o.x, o.y, t!.x, t!.y) < 600),
  },
});
